const renderTitle = (title: $TSFixMe, level: $TSFixMe) => {
  switch (level) {
    case 1:
      return <h1>{title}</h1>;
    case 2:
      return <h2>{title}</h2>;
    case 3:
      return <h3>{title}</h3>;
    case 4:
      return <h4>{title}</h4>;
    default:
      return <h5>{title}</h5>;
  }
};

type OwnHeadingProps = {
  id?: string;
  title?: string | React.ReactElement;
  level?: number;
  children?: React.ReactNode;
  className?: string;
};

const defaultProps: Partial<OwnHeadingProps> = {
  id: undefined,
  title: undefined,
  children: undefined,
  level: 1,
};

type HeadingProps = OwnHeadingProps & typeof defaultProps;

function Heading({ title, level, children, id, className }: HeadingProps) {
  return (
    <div id={id} className={`heading ${className ?? ""}`.trim()}>
      {renderTitle(title, level)}
      {children}
    </div>
  );
}

Heading.defaultProps = defaultProps;

export default Heading;
